<template>
  <div>
    <el-form
      size="small"
      ref="conditionTopForm"
      :model="conditionTopData"
      label-width="80px"
      inline
      class="margin-top-10"
      style="text-align: left"
    >
      <el-form-item label="TOP配置" required>
        <div class="top">
          <el-select
            v-model="conditionTopData.topCount"
            placeholder="请选择TOP"
            @change="$emit('change', conditionTopData.topCount)"
          >
            <el-option
              v-for="item in TOPlist"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //   用户TOP统计表单数据
      conditionTopData: {
        topCount: 10,
      },
      // browsers: [{ label: 'v1.0', value: '1.0' }, { label: 'v1.0', value: '1.1' }],
      TOPlist: [
        { label: 'TOP10', value: 10 },
        { label: 'TOP20', value: 20 },
        { label: 'TOP50', value: 50 },
        { label: 'TOP100', value: 100 },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.top {
  display: flex;
  .el-select {
    margin-right: 10px;
  }
}
</style>
